module.exports = __webpack_public_path__ + "static/media/sun.6f5ddd9b.svg";